import React, { Component } from 'react';
import PropTypes from 'prop-types';
import GreaterOrLessThanFilter from './greater-or-less-than-filter';
import { comparatorFilterParams } from '../constants/filter-types';
import { clearFilter, comparatorFilterMap } from '../filter-utils';

import ResetFilterButton from './reset-filter-button';

class GreaterOrLessThanFilterContainer extends Component{
    /* 
        The queryValue is based on the sign. It will be either one greater than or one less then the input value.
        This is due to the fact that the API is greater than or Equal To and Less then or Equal to. 
    */  
    state = {
        comparatorValue: comparatorFilterParams.greaterThan,
        error: false,
        inputValue: '',
        queryValue: '',
    }

    /***
     * BEGIN ag-grid required Methods https://www.ag-grid.com/javascript-grid-filter-component/#example-filtering-using-react-components
    ***/
    getModel = () => {
        const { inputValue } = this.state;

        if( inputValue === ''  ){

            return clearFilter();
        }

        return this.generateCustomQuery();
    }

    isFilterActive = () => {
        return this.state.queryValue !== '' ;
    }

    doesFilterPass = ( params ) => {
        const { comparatorValue, inputValue } = this.state;
        const { valueGetter } = this.props;
        const value =  valueGetter( params.node );

        let passesFilter = value < inputValue;

        if( comparatorValue === comparatorFilterParams.greaterThan ){
            passesFilter = value > inputValue;
        }

        return passesFilter;
    }

    setModel = () => {
        const { filterChangedCallback } = this.props;
        //Reset the internal state when ag-grid does a clear filters call
        this.setState( {
            comparatorValue: comparatorFilterParams.greaterThan,
            error: false,
            inputValue: '',
            queryValue: '',
        },  () => {
            filterChangedCallback();
        } );
    }
    /***
     * END ag-grid required methods
     ***/

    generateCustomQuery = () => {
        const { comparatorValue } = this.state;

        let comparatorBasedQueryParam = comparatorFilterMap( comparatorValue ).queryParam;
        let isZeroMailCount = comparatorValue === comparatorFilterParams.lessThan && this.state.queryValue === 0;

        if( isZeroMailCount ){
            comparatorBasedQueryParam = '';
        }

        return { customQuery: { queryParam: comparatorBasedQueryParam, value: this.state.queryValue } };
    }

    handleComparatorChange = ( e ) => {
        const { inputValue } = this.state;
        const updatedComparatorValue = e.target.value;
        let updatedQueryValue = '';
        let userInputError = false;


        if( inputValue !== '' ){
            updatedQueryValue = comparatorFilterMap( updatedComparatorValue ).queryValue( this.state.inputValue );
            userInputError = Math.sign( updatedQueryValue ) === -1;
        }

        this.setState( {
            comparatorValue: updatedComparatorValue,
            error: userInputError,
            queryValue: updatedQueryValue
        } );
    }
    onTextChange = ( e ) => {
        const isUserInputEmpty = e.target.value === '';
        const currentValue = isUserInputEmpty ? '' : parseInt( e.target.value );


        if( !isUserInputEmpty ){
            const queryValue = comparatorFilterMap( this.state.comparatorValue )
                .queryValue( parseInt( e.target.value ) );
            const userInputError = Math.sign( queryValue ) === -1;

            this.setState( { error: userInputError, inputValue: currentValue, queryValue: queryValue } );
        }
        else{
            this.resetFilter();
        }
    }

    onSubmit = ( e ) => {
        e.preventDefault();
        const { error, inputValue, comparatorValue } = this.state;
        const { filterChangedCallback } = this.props;
        const maxLimitReached = comparatorValue === comparatorFilterParams.greaterThan &&
        inputValue.toString().length > 15;

        if( !error && !maxLimitReached ){
            filterChangedCallback();
        }
    }

    resetFilter = ( e ) => {
        const { filterChangedCallback } = this.props;
        this.setState( {
            error: false,
            inputValue: '',
            queryValue: '',
        }, () => {
            filterChangedCallback();
        } );
    }

    render(){
        const { comparatorValue, error, inputValue } = this.state;
        return (
            <>
                <GreaterOrLessThanFilter
                    data-automation-id="greater-or-less-than-volume-filter"
                    onSubmit={this.onSubmit}
                    onTextChange={this.onTextChange}
                    inputValue={inputValue.toString()}
                    comparatorValue={comparatorValue}
                    handleComparatorChange={this.handleComparatorChange}
                    resetFilter={this.resetFilter}
                    error={error}
                />
                <ResetFilterButton onClick={this.resetFilter} />
            </>
        );
    }
};

GreaterOrLessThanFilterContainer.propTypes = {
    filterChangedCallback: PropTypes.func.isRequired,
    valueGetter: PropTypes.func.isRequired,
};

export default GreaterOrLessThanFilterContainer;
